const StyleInjector = (() => {
  let styleSheet = null;
  return {
    inject: (style) => {
      if (!styleSheet){
        StyleInjector.createStyleSheet()
      }
      styleSheet.insertRule(style, styleSheet.cssRules.length);
    },
    createStyleSheet: () => {
      const styleElement = document.createElement('style')
      document.head.appendChild(styleElement)

      styleSheet = styleElement.sheet
      console.log('styleSheet', styleSheet)
    }
  }
})()

export default StyleInjector;



// WEBPACK FOOTER //
// ./src/infra/StyleInjector.js